import { render } from "./SmallDoctorCard.vue?vue&type=template&id=1bcf50b0&scoped=true"
import script from "./SmallDoctorCard.vue?vue&type=script&lang=js"
export * from "./SmallDoctorCard.vue?vue&type=script&lang=js"

import "./SmallDoctorCard.vue?vue&type=style&index=0&id=1bcf50b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcf50b0"]])

export default __exports__